/**
 * @generated SignedSource<<50a2da85c2681b98a92238c493bc21b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsDatavizGraph_participativeModule",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsDatavizRootLayout_participativeModule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsDatavizGraphAnimation_participativeModule"
    }
  ],
  "type": "ParticipativeModule",
  "abstractKey": null
};

node.hash = "7148d5516da84984addfd32a8d99ae15";

module.exports = node;
